<div class="ui-g">
    <div class="ui-g-12">
        <div *ngIf="members_list.length!=0" class="ui-g">
            <div *ngFor="let member of members_list" class="ui-g-12">
                <div class="ui-g-6 ui-md-3">
                    <img [src]="member.value?.avatar_url==null || (member.value?.avatar_url!=null && member.value?.avatar_url.length=='0')?'./assets/images/test_profile.png':member.value.avatar_url"
                        class="avatar-image">
                </div>
                <div class="ui-g-6 ui-md-4 notranslate">
                    <p>
                        {{member.label | titlecase}}
                    </p>
                </div>
                <div class="ui-g-12 ui-md-5 buttons-space-around">
                    <button pButton (click)="editProfile(member.patient_guid)" [disabled]="this.process_loading"
                        icon="pi pi-external-link" label="Edit Profile"></button>
                    <button pButton (click)="showcardDialog(member.patient_guid)" [disabled]="this.process_loading"
                        icon="pi pi-external-link" label="ID Card"></button>
                </div>
            </div>

        </div>


        <p-dialog [(visible)]="displaycard" header="eGlobalDoctors Membership Card" [baseZIndex]="10000"
            *ngIf="displaycard">
            <div class="ui-g">
                <div class="ui-g-12">

                    <div class="ui-g"
                        style="background-color: #93bff9;border-top-right-radius:30px;border-top-left-radius: 30px;">
                        <!-- <div class="ui-g-5"></div> -->
                        <div class="ui-g-12 text-align-center">
                            <img src="assets/images/logo2.png" alt="" height="90" />
                            <!--<p style="font-size: 10px;">eGlobalDoctors</p>-->
                            <!-- <p style="font-size: 10px;margin-top: 1px;margin-left:5px;font-weight:bold">eGlobaldoctors</p> -->
                        </div>

                        <!-- <div class="ui-g-5"></div> -->
                    </div>

                    <div class="ui-g"
                        style="background-color: #ECECEC;border-bottom-left-radius: 30px;border-bottom-right-radius: 30px;">

                        <div class="ui-g-12">
                            <div class="ui-g-12">
                                <div class="ui-g-6">
                                    <label for="Mrn"><b>Medical Record Number</b></label><br>
                                    <div class="id_card_data notranslate">{{id_card.acronym}}
                                        {{id_card.medicalRecordNumber}}</div>
                                    <br>
                                    <label for="dob"><b>Date of birth</b></label><br>
                                    <div class="id_card_data">{{id_card.dateOfBirth}}</div>
                                    <label for="vtill"><b>Valid till</b></label><br>
                                    <div class="id_card_data">{{id_card.validTill}}</div><br>
                                </div>
                                <div class="ui-g-6">
                                    <!--<img [src]="(this.patient.avatar_url==null || (this.patient.avatar_url!=null && 
                                                this.patient.avatar_url.length==0)) ?'./assets/images/test_profile.png':this.patient.avatar_url"
                                                style="border-radius: 30%;margin-right:auto;margin-left:auto;" height='110' width='110'>-->

                                    <img [src]="id_card?.avatar_url==null || (id_card?.avatar_url!=null && id_card?.avatar_url.length==0)?'./assets/images/test_profile.png':id_card.avatar_url"
                                        class="avatar-image"><br>
                                    <label for="name"><b>Name</b></label><br>
                                    <div class="id_card_data notranslate">{{id_card.name | titlecase}}</div>

                                </div>
                                
                                <div class="ui-g-12" style="text-align: center;" *ngIf="!is_uk_country">
                                    <a href="#" onclick="return false;">eGlobalDoctors.com</a>
                                </div>
                                <div class="ui-g-12" style="text-align: center;" *ngIf="is_uk_country">
                                    <a href="#" onclick="return false;">eGlobalDoctors.co.uk</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p-footer>
                        <button pButton type="button" class="ui-button-warning" label="Cancel" icon="pi pi-times"
                            (click)="close()"></button>
                    </p-footer>
                </div>
            </div>
        </p-dialog>

    </div>
</div>